/**
 * @file Shared mobile feature-section navigation switcher.
 */

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("\"", "&quot;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

/**
 * Renders a mobile-only dropdown switcher for feature pages with internal tabs.
 * Desktop tab rows should stay in the owning feature renderer.
 * @param {object} options Switcher options.
 * @param {string} options.id Stable switcher id.
 * @param {string} options.label Accessible label.
 * @param {Array<{id: string, label: string}>} options.items Available sections.
 * @param {string} options.activeId Active section id.
 * @returns {string} Feature switcher HTML.
 */
export function renderFeatureNavSwitcher({
  id,
  label,
  items,
  activeId,
}) {
  const visibleItems = Array.isArray(items) ? items.filter((item) => item?.id) : [];
  if (visibleItems.length === 0) {return "";}

  const activeItem = visibleItems.find((item) => item.id === activeId) ||
    visibleItems[0];
  const escapedId = escapeHtml(id);
  const escapedLabel = escapeHtml(label);

  return `
    <details id="${escapedId}" class="feature-nav-switcher mb-6 md:hidden">
      <summary class="feature-nav-switcher__summary" aria-label="${escapedLabel}">
        <span class="feature-nav-switcher__active-label min-w-0 truncate">${escapeHtml(activeItem.label)}</span>
        <span class="material-symbols-outlined text-[20px]" aria-hidden="true">chevron_right</span>
      </summary>
      <div class="feature-nav-switcher__menu">
        ${visibleItems.map((item) => {
          const isActive = item.id === activeItem.id;
          return `
            <button
              type="button"
              class="feature-nav-switcher__option ${isActive ? "is-active" : ""}"
              data-feature-nav-option="${escapeHtml(item.id)}"
              aria-current="${isActive ? "page" : "false"}"
            >
              <span class="min-w-0 flex-1 truncate">${escapeHtml(item.label)}</span>
              ${isActive ? '<span class="material-symbols-outlined text-[18px]" aria-hidden="true">check</span>' : ''}
            </button>
          `;
        }).join("")}
      </div>
    </details>
  `;
}
